
export class Attachment {
    public __classname__: string = 'Attachment';
	
    public Rendition : string | null = null;
	public Type: string | null = null;
	public Content: string | null = null;
	public FilePath: string | null = null;
	public FileUrl: string | null = null;
	public EditionId: string | null = null;
	public ContentSourceFileLink: string | null = null;
	public ContentSourceProxyLink: string | null = null;
    
    constructor(params : AttachmentNamedParameters) {
        this.Rendition = params.Rendition ?? null;
        this.Type = params.Type ?? null;
        this.Content = params.Content ?? null;
        this.FilePath = params.FilePath ?? null;
        this.FileUrl = params.FileUrl ?? null;
        this.EditionId = params.EditionId ?? null;
        this.ContentSourceFileLink = params.ContentSourceFileLink ?? null;
        this.ContentSourceProxyLink = params.ContentSourceProxyLink ?? null;
    }

}

export interface AttachmentNamedParameters {
    Rendition?: string,
    Type?: string,
    Content?: string,
    FilePath?: string,
    FileUrl?: string,
    EditionId?: string,
    ContentSourceFileLink?: string,
    ContentSourceProxyLink?: string
}